import { WorkTaskStatus } from '../../api/api';

export const DEFAULT_STATUS_COLOR = '#a3a3a3';

const statusColors: Record<WorkTaskStatus, string> = {
  [WorkTaskStatus.Created]: '#8266E6',
  [WorkTaskStatus.ReadyForPlanning]: '#557FFE',
  [WorkTaskStatus.Planned]: '#FFBB89',
  [WorkTaskStatus.PlannedAppointment]: '#FF7A19',
  [WorkTaskStatus.OnRoute]: '#FFEE52',
  [WorkTaskStatus.Ongoing]: '#79C240',
  [WorkTaskStatus.Pause]: '#DC4040',
  [WorkTaskStatus.Completed]: '#60935D',
  [WorkTaskStatus.Processed]: '#C7C7C7',
  [WorkTaskStatus.Canceled]: DEFAULT_STATUS_COLOR
};

export const getWorkTaskStatusColor = (status?: WorkTaskStatus): string =>
  status ? statusColors[status] : DEFAULT_STATUS_COLOR;
